

import { useDispatch } from "react-redux"
import { actions } from "store"
import { AffliationRM } from "models/RM"
import { toastConfig } from "config"
import { toast } from "react-toastify"
import { application, testTakerRQ } from "store/hooks"
import { createAffiliationHooks } from ".."
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { editAffiliationFetch } from "store/middlewares/affiliation.crud"
import { initialize, reset } from "redux-form"
import { getUserDataFetch } from "store/middlewares/user.crud"
import qc from "keys/queryClient"
import { secretStorage } from "config"

const useEditAffiliation = (props) => {
    const { successMessage, errorMessage } = props || {}
    const dispatch = useDispatch()
    const setAlert = createAffiliationHooks.useAlert()
    const queryClient = useQueryClient()
    const setAppData = application.useSetAppData()

    // const userData = useQuery({
    //     queryKey: [qc.userData],
    //     queryFn: async () => {
    //         const { data } = await getUserDataFetch()
    //         const user = secretStorage.getItem("user")
    //         secretStorage.setItem("user", { ...user, user_data: data })
    //         setAppData(data)
    //         return data
    //     },
    //     enabled: false
    // })

    const { mutateAsync: editAff } = useMutation({
        mutationFn: editAffiliationFetch,
        onSuccess: () => {
            // userData.refetch()
            dispatch(reset("createAffliation"))
            dispatch(initialize('createAffliation', {}));
            queryClient.invalidateQueries({ queryKey: [qc.affiliations], exact: false, })
            queryClient.invalidateQueries({ queryKey: [qc.affiliation], exact: false, })
            toast(successMessage || " היחידה התעדכנה בהצלחה ", toastConfig)
        },
        onError: () => {
            toast.error(errorMessage || "ישנה בעייה בעדכון היחידה", toastConfig)
        }
    })

    const editAffiliation = async (values) => {
        const affiliation = new AffliationRM(values)
        const affiliationInstance = await editAff(affiliation)
        setAlert(false)
        return affiliationInstance
    }

    return editAffiliation
}

export default useEditAffiliation